/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon sort order dictionary
 */
export enum SortOrder {
  Ascending = 1,
  Descending
}
